<template>
  <div class="cargo-info-popup">
    <div class="popup-content">
      <div class="popup-title">
        {{ isEdit ? 'Edit' : 'Add' }} {{ title }}
      </div>
      <div class="content-details" v-if="title.includes('Sub')">
        <div>
          <Input placeholder="Pkg Qty" validator="integer,8" style="width: 130px; min-width: 130px; margin-right: 5px" textAlign="right"
            :inputValue.sync="subPkgDetails['pkgQty']" :isRequired="true" />
          <InputQuery placeholder="Pkg Type" :items="pkgTypeList" @focusChanged="calculateAllInput" itemKey="Code - Desc" descKey="Description"
            :selectedObject.sync="subPkgDetails['selectedPackageType']" :isRequired="true" 
            validator="text,65"/>
        </div>
        Dimensions
        <div>
          <Input placeholder="Length" :inputValue.sync="subPkgDetails['dimLength']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
          <div>X</div>
          <Input placeholder="Width" :inputValue.sync="subPkgDetails['dimWidth']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
          <div>X</div>
          <Input placeholder="Height" :inputValue.sync="subPkgDetails['dimHeight']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
        </div>
        <div>
          <Input placeholder="Total Gross (KG)" validator="positiveDecimal,5,4" style="margin-right: 5px" :inputValue.sync="subPkgDetails['totalGross']" @focusChanged="calculateAllInput" :isRequired="true" />
          <Input placeholder="Per Pkg (KG)" style="margin-left: 5px" :isDisabled="true" :inputValue.sync="subPkgDetails['grossPerPkg']" />
        </div>
        <div>
          <Input placeholder="Total Net (KG)" validator="positiveDecimal,5,4" style="margin-right: 5px" :inputValue.sync="subPkgDetails['totalNet']" @focusChanged="calculateAllInput" />
          <Input placeholder="Per Pkg (KG)" style="margin-left: 5px" :isDisabled="true" :inputValue.sync="subPkgDetails['netPerPkg']" />
        </div>
        <div>
          <Input placeholder="Total Vol (M³)" validator="positiveDecimal,5,4" :inputValue.sync="subPkgDetails['totalVol']" style="margin-right: 5px" :isDisabled="true" />
          <Input placeholder="Per Pkg (M³)" style="margin-left: 5px" :isDisabled="true" :inputValue.sync="subPkgDetails['volPerPkg']" />
        </div>
        <InputQuery placeholder="Item Code" :items="itemCode" itemKey="Product Code" descKey="Description"
          :selectedObject.sync="subPkgDetails['selectedItemCode']" validator="text,50" />
        <Input placeholder="Packing List #" :inputValue.sync="subPkgDetails['packingListNo']" validator="text,25"/>
        <Input placeholder="Invoice #" :inputValue.sync="subPkgDetails['invoiceNo']" validator="text,25"/>
        <Input placeholder="Container #" :inputValue.sync="subPkgDetails['containerNo']" validator="text,25"/>
        <Input placeholder="Remarks" :inputValue.sync="subPkgDetails['remarks']" validator="text,200"/>
      </div>
      <div class="content-details" v-if="title.includes('Cargo Info') && !title.includes('/')">
        <div>
          <InputQuery placeholder="Product" :isRequired="true" :items="productList" itemKey="Product Code" descKey="Description"
            :selectedObject.sync="truckDetails['truckSelectedProduct']" />
        </div>
        <div>
          <Input style="margin-right: 5px" placeholder="Qty" validator="integer,9" :inputValue.sync="truckDetails['truckSelectedQty']" :isRequired="true" @focusChanged="calculateAllInput" />
          <Dropdown :items="truckPackageList" style="margin-left: 5px" placeholder="Package" :isRequired="true" itemKey="Package Code"
            :selectedObject.sync="truckDetails['truckSelectedPackage']" />
        </div>

        <div>
          <Input style="margin-right: 5px" placeholder="Total KG"  :inputValue.sync="truckDetails['truckTotalKG']" ref="TotalKG" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
          <Input style="margin-left: 5px" placeholder="Total M³" :inputValue.sync="truckDetails['truckTotalM3']" ref="TotalM3"  @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
        </div>

        <div>
          <Dropdown :items="truckTypeList" style="margin-right: 5px; width: 320px" placeholder="Truck Type"  itemKey="Truck Type"
            :selectedObject.sync="truckDetails['truckSelectedType']" @selected="truckTypeSelected"/>
          <div>
              <InputQuery style="margin-left: 5px; width: 190px" placeholder="Bill Type"  :items="truckBillTypeList" itemKey="Description" descKey="BillType"
              :selectedObject.sync="truckDetails['truckSelectedBillType']" @selected="billTypeSelected" />
          </div>
        </div>

        <div>
          <Dropdown :items="truckBillCodes" placeholder="Bill Code" style="margin-right: 5px; width: 320px" itemKey="BillRateCode"
            :selectedObject.sync="truckDetails['truckSelectedBillCode']" :isDisabled="billcodemode" @selected="billCodeSelected" />
          <div style="flex-direction: row">
            <Input placeholder="Bill Rate" style="margin-left: 5px; width: 190px" title="Bill Rate" text-align="right" :isDisabled="billrateviewmode" validator="positiveDecimal,7,4"
              :inputValue.sync="truckDetails['truckBillRate']" @focusChanged="calculateAllInput"/>
          </div>
        </div>


      </div>
      <div class="content-details" v-if="title.includes('Send To')">
        <div>
          <Input placeholder="Pkg Qty" style="width: 130px; min-width: 130px; margin-right: 5px" textAlign="right" validator="integer,8"
            :inputValue.sync="truckDetails['truckSelectedQty']" :isRequired="true" @focusChanged="calculateAllInput" />
          <InputQuery placeholder="Pkg Type" :items="truckPackageList" @focusChanged="calculateAllInput" itemKey="Package Code" descKey="Description"
            :selectedObject.sync="truckDetails['truckSelectedPackage']" :isRequired="true" />
        </div>
        Dimensions
        <div>
          <Input placeholder="Length" :inputValue.sync="truckDetails['dimLength']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
          <div>X</div>
          <Input placeholder="Width" :inputValue.sync="truckDetails['dimWidth']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
          <div>X</div>
          <Input placeholder="Height" :inputValue.sync="truckDetails['dimHeight']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>
        </div>
        <div>
          <Input placeholder="Total KG" style="margin-right: 5px" :inputValue.sync="truckDetails['truckTotalKG']" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4"/>

          <Input placeholder="Per KG" style="margin-left: 5px" :isDisabled="true" :inputValue.sync="truckDetails['truckPerKG']" />
        </div>
        <div>
          <Input placeholder="Total M³" :inputValue.sync="truckDetails['truckTotalM3']" style="margin-right: 5px" @focusChanged="calculateAllInput" validator="positiveDecimal,5,4" :isDisabled="true"/>
          <Input placeholder="Per M³" style="margin-left: 5px" :isDisabled="true" :inputValue.sync="truckDetails['truckPerM3']" />
        </div>
        <div>
          <Input placeholder="Volume Divisor" :inputValue.sync="truckDetails['truckVolumeDivisor']" style="margin-right: 5px" :isDisabled="true" />
          <!-- <Dropdown :items="truckVolumeDivisorList" style="margin-right: 5px" :allowFreeText="true" placeholder="Volume Divisor" itemKey="TMS_VolDivisor"
            :selectedObject.sync="truckDetails['truckVolumeDivisor']"  /> -->
          <Input placeholder="Volume Weight" :inputValue.sync="truckDetails['truckVolumeWeight']" style="margin-left: 5px" :isDisabled="true" />
        </div>
        <div>
          <InputQuery placeholder="Product" :isRequired="true" :items="productList" itemKey="Product Code" descKey="Description"
            :selectedObject.sync="truckDetails['truckSelectedProduct']" />
        </div>
        <div>
          <Dropdown :items="truckTypeList" style="margin-right: 5px; width: 320px" placeholder="Truck Type"  itemKey="Truck Type"
            :selectedObject.sync="truckDetails['truckSelectedType']" @selected="truckTypeSelected"/>
          <div>
            <InputQuery style="margin-left: 5px; width: 190px" placeholder="Bill Type"  :items="truckBillTypeList" itemKey="Description" descKey="BillType"
              :selectedObject.sync="truckDetails['truckSelectedBillType']" @selected="billTypeSelected" />
          </div>
        </div>
        <div>
          <Dropdown :items="truckBillCodes" placeholder="Bill Code" itemKey="BillRateCode" style="margin-right: 5px; width: 320px" 
            :selectedObject.sync="truckDetails['truckSelectedBillCode']" :isDisabled="billcodemode" @selected="billCodeSelected" />
          <div style="flex-direction: row">
            <Input placeholder="Bill Rate" style="margin-left: 5px; width: 190px" title="Bill Rate" text-align="right" :isDisabled="billrateviewmode" validator="positiveDecimal,7,4"
              :inputValue.sync="truckDetails['truckBillRate']" @focusChanged="calculateAllInput"/>
          </div>
        </div>
        <div>
          <Input placeholder="Temp." :inputValue.sync="truckDetails['truckTemp']" style="margin-right: 5px" validator="text,10" />
          <Input placeholder="Est Trucks" :inputValue.sync="truckDetails['truckEstTrucks']" validator="integer,1"/>
          <!-- <Dropdown :items="truckTypeList" style="margin-right: 5px; width: 320px" placeholder="Truck Type"  itemKey="Truck Type"
            :selectedObject.sync="truckDetails['truckSelectedType']" @selected="truckTypeSelected"/>
          <Dropdown :items="truckTruckTypeList" style="margin-left: 5px" placeholder="Truck Type" :isRequired="true" itemKey="TruckType"
            :selectedObject.sync="truckDetails['truckSelectedTruckType']" /> -->
        </div>
        <div>
          <Dropdown :items="truckContNoList" style="margin-right: 5px" placeholder="Cont. #" itemKey="Container Code"
            :selectedObject.sync="truckDetails['truckSelectedContNo']" :search.sync="truckDetails['truckInputedContNo']" :allowFreeText="true"/>

          <Input placeholder="Seal #" :inputValue.sync="truckDetails['truckSealNo']" />
          <Input placeholder="Opr" :inputValue.sync="truckDetails['truckOpr']" style="margin-left: 5px" />
        </div>
        <div>
          <Dropdown :items="truckContSizeList" style="margin-right: 5px" placeholder="Cont. Size" itemKey="Size"
            :selectedObject.sync="truckDetails['truckSelectedContSize']" />
          <Dropdown :items="truckContTypeList" style="margin-left: 5px" placeholder="Cont. Type" itemKey="Cont Type"
            :selectedObject.sync="truckDetails['truckSelectedContType']" />
        </div>
        <RemarksBox title="Remarks" :text.sync="truckDetails['truckSelectedRemarks']" style="height: 100px" :freeText="true" />
        

      </div>
      <div class="content-details" v-if="title.includes('Container')">
        <div>
          <Dropdown style="margin-right: 5px; width: 50%" placeholder="Please select" :isRequired="true" :items="categoryItems" itemKey="desc"
            :selectedObject.sync="selectedCategory" />
          <div v-if="selectedCategory" style="display: flex; align-items: center; width: 100%">
            <Input v-if="selectedCategory['desc'] == 'Container Required'" style="margin-left: 5px" placeholder="Cont Quantity" :inputValue.sync="contDetails['contQty']" :isRequired="true" textType="number" />
            <Input v-if="selectedCategory['desc'] == 'Cont/Seal #'" validator="text,20" style="margin-left: 5px" placeholder="Container #" :inputValue.sync="contDetails['contNo']" :isRequired="true" /> 
            <Input v-if="selectedCategory['desc'] == 'Cont/Seal #'" validator="text,20" style="margin-left: 5px" placeholder="Seal #" :inputValue.sync="contDetails['sealNo']" />
          </div>
        </div>
        <div>
          <Dropdown :items="contSizeList" placeholder="Size" :isRequired="true" itemKey="Size"
            :selectedObject.sync="contDetails['contSelectedSize']" />
          <Dropdown :items="contTypeList" style="margin-left: 5px" placeholder="Type" :isRequired="true" itemKey="Cont Type"
            :selectedObject.sync="contDetails['contSelectedType']" />
        </div>
        <div>
          <Dropdown :items="contStatusList" placeholder="Status" itemKey="Cont Status"
            :selectedObject.sync="contDetails['contSelectedStatus']" />
          <Input style="margin-left: 5px" placeholder="Weight (KG)" :inputValue.sync="contDetails['contWeight']" textType="number" />
        </div>
        <InputQuery :items="contHandlingTypeList" placeholder="Handling Type" itemKey="Handling Type" descKey="Description" :isRequired="true"
          :selectedObject.sync="contDetails['contSelectedHdgType']" />
        <InputQuery :items="contDeliveryTypeList" placeholder="Delivery Type" itemKey="Delivery Type" descKey="Description" :isRequired="true"
          :selectedObject.sync="contDetails['contSelectedDelType']" />
        <InputQuery :items="contSendToList" placeholder="Send To" itemKey="Destination Code" descKey="Company"
          :selectedObject.sync="contDetails['contSelectedSendTo']" />
        <Dropdown :items="soccocTypeList" itemKey="SOCCOC Type" placeholder="SOC/COC" :isRequired="true" :selectedObject.sync="contDetails['contSocCoc']" />
        <!-- <Input placeholder="SOC/COC" :inputValue.sync="contDetails['contSocCoc']" /> -->
        <RemarksBox :maxLength="200" style="height: 150px" :text.sync="contDetails['contRemarks']" />
      </div>
      <div class="popup-button">
        <div v-if="showPopup" class="popup-error">{{errMesssage}}</div>
        <button @click="addDetails()">{{ isEdit ? 'Edit' : 'Add' }}</button>
        <button @click="$emit('cancel')">Cancel</button>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
import RemarksBox from '@/components/RemarksBox.vue';

export default {
  components: {
    RemarksBox
  },
  data: function() {
    return {
      errMesssage: '',
      sendtoTrucktype: false,
      billcodemode: true,
      billtypeselect: false,
      trucktypeselect: false,
      showPopup: false,
      billrateviewmode: true,

      categoryItems: [
        { desc: 'Container Required' },
        { desc: 'Cont/Seal #' },
      ],
      selectedCategory: { desc: 'Container Required' },

      soccocItems: [
        { desc: 'SOC - Shipper-Owned-Container' },
        { desc: 'COC - Carrier-Owned-Container' }
      ],

      subPkgDetails: {
        pkgQty: null,
        selectedPackageType: null,

        dimLength: null,
        dimWidth: null,
        dimHeight: null,

        totalGross: '',
        grossPerPkg: '',

        totalNet: '',
        netPerPkg: '',

        totalVol: '',
        volPerPkg: '',

        selectedItemCode: null,

        packingListNo: null,
        invoiceNo: null,
        containerNo: null,
        remarks: null
      },
      contDetails: {
        contQty: null,
        contNo: null,
        oldcontNo: null,
        sealNo: null,
        contWeight: null,
        sendTo: null,
        contSocCoc: null,

        contSelectedSize: null,
        contSelectedType: null,

        contSelectedStatus: null,

        contSelectedHdgType: null,
        contSelectedDelType: null,
        contSelectedSendTo: null,
        contRemarks: null
      },
      truckDetails: {
        truckSelectedProduct: null,
        truckSelectedQty: '',
        truckSelectedPackage: null,

        truckTotalKG: '',
        truckTotalM3: '',

        truckSelectedType: null,
        truckSelectedBillType: null,
        truckSelectedBillCode: null,

        truckBillRate: '',

        dimLength: null,
        dimWidth: null,
        dimHeight: null,

        truckPerKG: '',
        truckPerM3: '',
        // truckVolumeDivisor: {"TMS_VolDivisor": "5000"},
        truckVolumeDivisor: '5000',
        truckVolumeWeight: null,

        truckTemp: null,
        truckEstTrucks: null,
        truckSelectedTruckType: null,

        truckSelectedContNo: null,
        truckInputedContNo: "",
        truckSealNo: null,
        truckOpr: null,

        truckSelectedContSize: null,
        truckSelectedContType: null,

        truckSelectedRemarks: null
      },
      truckBillCodes: [],
    }
  },
  props: {
    title: { type: String, default: '' },
    pageType: { type: String, default: '' },

    pkgTypeList: { type: Array, default: function() { return [] } },
    itemCode: { type: Array, default: function() { return [] } },

    contSizeList: { type: Array, default: function() { return [] } },
    contTypeList: { type: Array, default: function() { return [] } },

    contStatusList: { type: Array, default: function() { return [] } },

    contHandlingTypeList: { type: Array, default: function() { return [] } },
    contDeliveryTypeList: { type: Array, default: function() { return [] } },
    soccocTypeList: { type: Array, default: function() { return [] } },
    contSendToList: { type: Array, default: function() { return [] } },
    
    isEdit: { type: Boolean, default: false },
    editDetails: { type: Object, default: function() { return null } },

    productList: { type: Array, default: function() { return [] } },
    // truckQtyList: { type: Array, default: function() { return [] } },
    truckPackageList: { type: Array, default: function() { return [] } },

    truckTypeList: { type: Array, default: function() { return [] } },
    truckBillTypeList: { type: Array, default: function() { return [] } },

    truckBillCodeList: { type: Array, default: function() { return [] } },

    truckTruckTypeList: { type: Array, default: function() { return [] } },
    truckContNoList: { type: Array, default: function() { return [] } },

    truckContSizeList: { type: Array, default: function() { return [] } },
    truckContTypeList: { type: Array, default: function() { return [] } },

    truckVolumeDivisorList: {type: Array, default: function() { return [] }},

    jobDateTime: { type: String, default: '' }
  },
  methods: {
    addDetails: function() {
      this.showPopup = false;
      this.errMesssage = 'Please make sure that all the required fields are filled in.';
      var isSub = this.title.includes('Sub');
      var isCargo = this.title.includes('Cargo');
      var noError = this.checkError(isSub);
      var noErrorCargo = this.checkErrorT(isCargo);
      if (!isCargo) {
        if (!noError) {
          this.showPopup = true;
          return;
        }

        if (isSub) {
          this.$emit('addDetails', 'sub', this.subPkgDetails);
        } else {
          if (this.selectedCategory['desc'] == 'Container Required') {
            var count = parseInt(this.contDetails['contQty']);
            this.$emit('addDetails', 'cont', Array(count).fill(this.contDetails));
          } else {
            this.$emit('addDetails', 'cont', this.contDetails);
          }
        }
      } else if (isCargo) {
        if (!noErrorCargo) {
          this.showPopup = true;
          return;
        }
        if (this.title.includes('Cargo Info')) {
          this.$emit('addDetails', 'Cargo', this.truckDetails);
        } else {
          this.$emit('addDetails', 'Cargo', this.truckDetails);
        }
      }
    },
    formatCurrencySeperator: function (value){
      if (value)
        return this.$currencyFormat(value.replaceAll(',', '')).replaceAll(',', '') // remove seperator, currency format, remove seperator again
    else return this.$currencyFormat('0');
    },
    formatWeightValue: function(value){ // to format value to weight format with decimals and remove the separator to avoid issues
    if (value){
      if (typeof value === 'number') {
            value = value.toString();
        }
      value = value.replaceAll(',', '')
      return this.$weightFormat(value).replaceAll(',', '');
    }
    else return this.$weightFormat('0');
    },
    calculateAllInput: function() {
      if (this.subPkgDetails['dimLength'] && this.subPkgDetails['dimWidth'] && this.subPkgDetails['dimHeight']) {
        var vol = (this.subPkgDetails['dimLength']) * (this.subPkgDetails['dimWidth']) * (this.subPkgDetails['dimHeight']);
        this.subPkgDetails['volPerPkg'] = this.formatWeightValue(vol);
        if (this.subPkgDetails['pkgQty']) {
          this.subPkgDetails['totalVol'] = this.formatWeightValue(vol * parseInt(this.subPkgDetails['pkgQty']));
        } else {
          this.subPkgDetails['totalVol'] = this.$weightFormat('0');
        }

        this.subPkgDetails['dimHeight'] = this.formatWeightValue(this.subPkgDetails['dimHeight']);
        this.subPkgDetails['dimLength'] = this.formatWeightValue(this.subPkgDetails['dimLength']);
        this.subPkgDetails['dimWidth'] = this.formatWeightValue(this.subPkgDetails['dimWidth']);

        if (this.subPkgDetails['volPerPkg'].toString().split('.')[0].length > 7 || this.subPkgDetails['totalVol'].toString().split('.')[0].length > 7) {
          this.$showAlert(
            'warning',
            'Volume (M³) cannot exceed 7 digits',
            'The calculated volume exceeds the limit of 7 digits. Please enter valid dimensions.',
            [{ "text": "OK" }]
          );
            // Reset dimensions if volume exceeds the limit
            this.subPkgDetails['dimHeight'] = this.$weightFormat('0');
            this.subPkgDetails['dimLength'] = this.$weightFormat('0');
            this.subPkgDetails['dimWidth'] = this.$weightFormat('0');
            this.subPkgDetails['totalVol'] = this.$weightFormat('0');
            this.subPkgDetails['volPerPkg'] = this.$weightFormat('0');
        }

      } else {
        this.subPkgDetails['dimHeight'] = this.$weightFormat('0'); // default these to 0 if empty
        this.subPkgDetails['dimLength'] = this.$weightFormat('0');
        this.subPkgDetails['dimWidth'] = this.$weightFormat('0');
        this.subPkgDetails['volPerPkg'] = this.$weightFormat('0');
        this.subPkgDetails['totalVol'] = this.$weightFormat('0');
      }
      
      if (this.subPkgDetails['totalGross'] && this.subPkgDetails['pkgQty']) {
        this.subPkgDetails['grossPerPkg'] = this.formatWeightValue((this.subPkgDetails['totalGross']) / parseInt(this.subPkgDetails['pkgQty']));
      } else {
        this.subPkgDetails['grossPerPkg'] = this.$weightFormat('0');
      }
      
      if (this.subPkgDetails['totalNet'] && this.subPkgDetails['pkgQty']) {
        this.subPkgDetails['netPerPkg'] = this.formatWeightValue((this.subPkgDetails['totalNet']) / parseInt(this.subPkgDetails['pkgQty']));
      } else {
        this.subPkgDetails['netPerPkg'] = this.$weightFormat('0');
      }

      if (this.subPkgDetails['totalGross']){
        this.subPkgDetails['totalGross'] = this.formatWeightValue(this.subPkgDetails['totalGross']);
      } else {this.subPkgDetails['totalGross'] = this.$weightFormat('0');}
      if (this.subPkgDetails['totalNet']){
        this.subPkgDetails['totalNet'] = this.formatWeightValue(this.subPkgDetails['totalNet']);
      } else {this.subPkgDetails['totalNet'] = this.$weightFormat('0');}

      // Trucking Job 
      if (this.truckDetails['truckBillRate']) {
        this.truckDetails['truckBillRate'] =  Number(this.truckDetails['truckBillRate']).toFixed(2);
      }
      
      if ((this.truckDetails['dimLength'] && this.truckDetails['dimWidth'] && this.truckDetails['dimHeight'])
          && this.title.includes('Send To')) { // Don't calculate Total M3 base on Dimensions if opened from "Quick Entry tab"
        var vol = (this.truckDetails['dimLength']) * (this.truckDetails['dimWidth']) * (this.truckDetails['dimHeight']);
        this.truckDetails['truckPerM3'] = this.formatWeightValue(vol);


        if (!(this.truckDetails['truckSelectedQty'] == 0)) { 
          this.truckDetails['truckTotalM3'] = this.formatWeightValue(vol * parseInt(this.truckDetails['truckSelectedQty']));
        }

        this.truckDetails['dimHeight'] = this.formatWeightValue(this.truckDetails['dimHeight']);
        this.truckDetails['dimLength'] = this.formatWeightValue(this.truckDetails['dimLength']);
        this.truckDetails['dimWidth'] = this.formatWeightValue(this.truckDetails['dimWidth']);

        if (this.truckDetails['truckPerM3'].toString().split('.')[0].length > 7 || this.truckDetails['truckTotalM3'].toString().split('.')[0].length > 7) {
          this.$showAlert(
            'warning',
            'Volume Weight cannot exceed 7 digits',
            'The calculated volume exceeds the limit of 7 digits. Please enter valid dimensions.',
            [{ "text": "OK" }]
          );
            // Reset dimensions if volume exceeds the limit
            this.truckDetails['dimHeight'] = this.$weightFormat('0');
            this.truckDetails['dimLength'] = this.$weightFormat('0');
            this.truckDetails['dimWidth'] = this.$weightFormat('0');
            this.truckDetails['truckTotalM3'] = this.$weightFormat('0');
            this.truckDetails['truckPerM3'] = this.$weightFormat('0');
        }
      } else if (this.title.includes('Send To')){ // Don't reset values if opened from "Quick Entry" tab
            this.truckDetails['dimHeight'] = this.$weightFormat('0');
            this.truckDetails['dimLength'] = this.$weightFormat('0');
            this.truckDetails['dimWidth'] = this.$weightFormat('0');
            this.truckDetails['truckPerKG'] = this.$weightFormat('0');
            this.truckDetails['truckTotalM3'] = this.$weightFormat('0');
            this.truckDetails['truckPerM3'] = this.$weightFormat('0');
      }


      if (this.truckDetails['truckTotalM3']) {
        this.truckDetails['truckTotalM3'] = this.formatWeightValue((this.truckDetails['truckTotalM3']));
      } else {
        this.truckDetails['truckPerM3'] = this.$weightFormat('0');
      }

      
      
      if (this.truckDetails['truckTotalKG']) {
        this.truckDetails['truckTotalKG'] = this.formatWeightValue((this.truckDetails['truckTotalKG']));

        if (!(this.truckDetails['truckSelectedQty'] == 0)) {
          this.truckDetails['truckPerKG'] = this.formatWeightValue(this.truckDetails['truckTotalKG'] / this.truckDetails['truckSelectedQty']);
        }

      } else {
        this.truckDetails['truckPerKG'] = this.$weightFormat('0');
      }
      
      if (this.truckDetails['truckPerM3'] && (this.truckDetails['truckVolumeDivisor'] != null)) {
        this.truckDetails['truckVolumeWeight'] = this.formatWeightValue(parseInt(this.truckDetails['truckPerM3']*1000000)/this.truckDetails['truckVolumeDivisor']);
      }
    },
    checkErrorT: function(truck) {
      if (truck) {
        if (!this.truckDetails['truckSelectedProduct'] || 
            !this.truckDetails['truckSelectedQty'] || 
            this.truckDetails['truckSelectedQty'].trim() === '' ||
            !this.truckDetails['truckSelectedPackage']) {
            
              this.errMesssage = 'Please make sure that all the required fields are filled in.'
            return false;
        }else if(this.truckDetails['truckSelectedQty'] == '0'){
          this.errMesssage = 'Qty cannot be 0.'
            return false;
        }else {
          return true;
        }
      } else {
        if (!this.selectedCategory) {
          return false;
        }


      }
      // else if (truck == 'Send To') {
      //   if (this.truckDetails['truckSelectedProduct'] && truckDetails['truckSelectedQty'] && truckDetails['truckSelectedPackage']) {
      //     return true;
      //   } else {
      //     return false;
      //   }
      // }

    },
    checkError: function(sub) {
      if (sub) {
        if (this.subPkgDetails['pkgQty'] && this.subPkgDetails['selectedPackageType'] && this.subPkgDetails['totalGross']) {
          return true;
        } else{
          return false;
        }
      } else {
        if (!this.selectedCategory) {
          return false;
        }

        if (this.selectedCategory['desc'] == 'Container Required') {
          if (this.contDetails['contQty'] && this.contDetails['contSelectedSize'] && this.contDetails['contSelectedType'] && this.contDetails['contSelectedHdgType'] && this.contDetails['contSelectedDelType'] && this.contDetails['contSocCoc']) {
            return true;
          } else {
            return false;
          }
        } else {
          if (this.contDetails['contNo'] && this.contDetails['contSelectedSize'] && this.contDetails['contSelectedType'] && this.contDetails['contSelectedHdgType'] && this.contDetails['contSelectedDelType'] && this.contDetails['contSocCoc']) {
            return true;
          } else {
            return false;
          }
        }
      }
    },
    billTypeSelected: function(e) {
      if(e){
        this.$emit('sendToBillCode', e['BillType']);
        this.billtypeselect = true;
        
        let temp = e['BillType'];
        this.m3 = this.truckDetails['truckTotalM3'];
        this.kg = this.truckDetails['truckTotalKG'];

        if (temp == null) {
          this.billcodemode = false;
          this.billrateviewmode = false;
          this.sendtoTrucktype = false;
        }

        if (temp == 1 || temp == 2) { 
          this.sendtoTrucktype = true;
          this.billcodemode = false;
          this.billrateviewmode = true;
        }

        if (this.billtypeselect && this.trucktypeselect && (this.sendtoTrucktype == true) ) {
          this.billcodemode = false;
          this.billrateviewmode = true;
        }

        if (temp == 0 || temp == 3 || temp == 4) {
          this.billcodemode = true;
          this.billrateviewmode = false;
          this.sendtoTrucktype = false;
        }

        if (temp == 1 || temp == 2) {
          this.sendtoTrucktype = true;
        }

        if (this.billtypeselect && this.trucktypeselect && (this.sendtoTrucktype == true) ) {
          this.billcodemode = false;
          this.billrateviewmode = true;
        }
      }
    },
    truckTypeSelected: function(e) {
      if(e){
        this.$emit('sendToTruckType', e['Truck Type']);
        this.trucktypeselect = true;

        if (this.billtypeselect && this.trucktypeselect && (this.sendtoTrucktype == true) ) {
          this.billcodemode = false;
          //this.billrateviewmode = true;
        }
      }
    },
    billCodeSelected: async function(e) {
      if(e){
        let dataToPost = {
          'billratecode': e['BillRateCode'] ? e['BillRateCode'] : '',
          'billratetype': this.truckDetails['truckSelectedBillType'] ? this.truckDetails['truckSelectedBillType']['BillType'] ? this.truckDetails['truckSelectedBillType']['BillType'] : '' : '',
          'vehiclecategory': this.truckDetails['truckSelectedType'] ? this.truckDetails['truckSelectedType']['Truck Type'] ? this.truckDetails['truckSelectedType']['Truck Type'] : '' : '',
          'jobdate': this.jobDateTime,
          'qty': this.truckDetails['truckSelectedQty'] ? this.truckDetails['truckSelectedQty'] : '',
          'packagecode': this.truckDetails['truckSelectedPackage'] ? this.truckDetails['truckSelectedPackage']['Package Code'] ? this.truckDetails['truckSelectedPackage']['Package Code'] : '' : '',
          'productcode': this.truckDetails['truckSelectedProduct'] ? this.truckDetails['truckSelectedProduct']['Product Code'] ? this.truckDetails['truckSelectedProduct']['Product Code'] : '' : '',
          'totalkg': this.truckDetails['truckTotalKG'] ? this.truckDetails['truckTotalKG'] : '',
          'totalm3': this.truckDetails['truckTotalM3'] ? this.truckDetails['truckTotalM3'] : '',
          'totalpallets': '',
          'totaltrucks': ''
        };
      
        this.$fullscreenLoading('Getting Bill Rate');
        let billRate = await this.$apiCallV2('/TruckingJob/GetTMSBillRate', dataToPost);
        this.truckDetails['truckBillRate'] = billRate[0]['SelectedRate'] ? Number(billRate[0]['SelectedRate']).toFixed(2) : '0.00';
        this.truckDetails['truckTotalCharge'] = billRate[0]['TptCharges'];
        this.truckDetails['truckTollCharge'] = billRate[0]['TollChg'];
        this.$fullscreenLoading();
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      this.truckVolumeDivisor= {"TMS_VolDivisor": "5000"}
    });
    
    this.truckDetails.truckTotalKG = this.$weightFormat(this.truckDetails.truckTotalKG);
    this.truckDetails.truckTotalM3 = this.$weightFormat(this.truckDetails.truckTotalM3);
    // console.log(this.truckDetails.truckTotalKG);
    this.truckDetails.truckBillRate = this.$currencyFormat(this.truckDetails.truckBillRate);
    //this.truckDetails.truckSelectedQty = this.$currencyFormat(this.truckDetails.truckSelectedQty);

    if (this.pageType == 'Import') {
      this.$nextTick(() => this.selectedCategory = { desc: 'Cont/Seal #' });
    } else {
      this.$nextTick(() => this.selectedCategory = { desc: 'Container Required' });
    }

    // for FMS 
    if (this.editDetails && this.title.includes('Sub')) {
      let dimensions = this.editDetails['Dimensions'].split('X').map(d => d.replace('m', '').trim());

      this.subPkgDetails['pkgQty'] = this.editDetails['Package Quantity'];
      this.subPkgDetails['selectedPackageType'] = this.pkgTypeList.getSelected(this.editDetails['Package Type'], 'Package Code');
      this.subPkgDetails['dimLength'] = dimensions[0];
      this.subPkgDetails['dimWidth'] = dimensions[1];
      this.subPkgDetails['dimHeight'] = dimensions[2];
      this.subPkgDetails['totalGross'] = this.editDetails['Gross Weight'].replaceAll(',', '').split('KG')[0];
      this.subPkgDetails['grossPerPkg'] = '0.00';
      this.subPkgDetails['totalNet'] = this.editDetails['Net Weight'].replaceAll(',', '').split('KG')[0];
      this.subPkgDetails['netPerPkg'] = '0.00';
      this.subPkgDetails['totalVol'] = this.editDetails['Volume'].replaceAll(',', '').split('M³')[0];
      this.subPkgDetails['volPerPkg'] = '0.00';
      this.subPkgDetails['selectedItemCode'] = this.itemCode.getSelected(this.editDetails['Item Code'], 'Product Code');
      this.subPkgDetails['packingListNo'] = this.editDetails['Packing List #'];
      this.subPkgDetails['invoiceNo'] = this.editDetails['Invoice #'];
      this.subPkgDetails['containerNo'] = this.editDetails['Container #'];
      this.subPkgDetails['remarks'] = this.editDetails['Remarks'];

    } else if (this.editDetails) {
      this.$nextTick(() => this.selectedCategory = this.categoryItems[1]);

      this.contDetails['contQty'] = null; // null;
      this.contDetails['contNo'] = this.editDetails['Cont #']; // null;
      this.contDetails['oldcontNo'] = this.editDetails['Old Cont #'];
      this.contDetails['sealNo'] = this.editDetails['Seal No']; // null;
      this.contDetails['contWeight'] = this.editDetails['Cont Weight']; // null;
      this.contDetails['sendTo'] = this.contSendToList.getSelected(this.editDetails['Send To'], 'Destination Code'); // null;
      // this.contDetails['contSocCoc'] = this.editDetails['Cont Soc Coc']; // null;
      this.contDetails['contSocCoc'] = this.soccocTypeList.getSelected(this.editDetails['SOC/COC'], 'SOCCOC Type');
      this.contDetails['contSelectedSize'] = this.contSizeList.getSelected(this.editDetails['Cont Size'], 'Size'); // null;
      this.contDetails['contSelectedType'] = this.contTypeList.getSelected(this.editDetails['Cont Type'], 'Cont Type'); // null;
      this.contDetails['contSelectedStatus'] = this.contStatusList.getSelected(this.editDetails['Status'], 'Cont Status'); // null;
      this.contDetails['contSelectedHdgType'] = this.contHandlingTypeList.getSelected(this.editDetails['Handling Type'], 'Handling Type'); // null;
      this.contDetails['contSelectedDelType'] = this.contDeliveryTypeList.getSelected(this.editDetails['Delivery Type'], 'Delivery Type'); // null;
      this.contDetails['contSelectedSendTo'] = this.contSendToList.getSelected(this.editDetails['Send To'], 'Destination Code'); // null;
      this.contDetails['contRemarks'] = this.editDetails['Remarks']; // null;
      this.contDetails['From API'] = this.editDetails['From API'] || false; // null;
    } 
    if (this.title.includes('Sub')){ this.calculateAllInput(); } // to initialize values during edit / add sub pakages

    
    if (this.editDetails && this.title.includes('Cargo Info') || this.editDetails && this.title.includes('Send To')) {//for trucking job consignment
      // let dimensions = this.editDetails['Dimensions'] ? this.editDetails['Dimensions'].split('X').map(d => d.replace('m', '').trim()) : null;

      this.truckDetails['truckSelectedProduct'] = this.productList.getSelected(this.editDetails['Product'], 'Product Code');
      this.truckDetails['truckSelectedPackage'] = this.truckPackageList.getSelected(this.editDetails['Package'], 'Package Code');
      this.truckDetails['truckSelectedType'] = this.truckTypeList.getSelected(this.editDetails['Truck Type'], 'Truck Type');

      // this.truckDetails['dimLength'] = dimensions ? dimensions[0] : '';
      // this.truckDetails['dimWidth'] = dimensions ? dimensions[1] : '';
      // this.truckDetails['dimHeight'] = dimensions ? dimensions[2] : '';

      this.truckDetails['truckPerKG'] = this.editDetails['Per KG'];
      this.truckDetails['truckPerM3'] = this.editDetails['Per M3'];
      this.truckDetails['truckVolumeDivisor'] = this.editDetails['Volume Divisor'];
      this.truckDetails['truckVolumeWeight'] = this.editDetails['Volume Weight'];
      this.truckDetails['truckTemp'] = this.editDetails['Temp'];
      this.truckDetails['truckEstTrucks'] = this.editDetails['Est Trucks'];
      this.truckDetails['truckSelectedContNo'] = this.truckContNoList.getSelected(this.editDetails['Cont. #'], 'Container Code');
      this.truckDetails['truckInputedContNo'] = this.editDetails['Cont. #'];
      this.truckDetails['truckSealNo'] = this.editDetails['Seal #'];
      this.truckDetails['truckOpr'] = this.editDetails['Opr'];
      this.truckDetails['truckSelectedContSize'] = this.truckContSizeList.getSelected(this.editDetails['Cont. Size'], 'Size');
      this.truckDetails['truckSelectedContType'] = this.truckContTypeList.getSelected(this.editDetails['Cont. Type'], 'Cont Type');
      this.truckDetails['truckSelectedRemarks'] = this.editDetails['Remarks'];

      this.$nextTick(async() => {
        this.truckDetails['truckSelectedQty'] = String(this.editDetails['Qty']);
        this.truckDetails['truckTotalKG'] = this.editDetails['Total KG'];
        this.truckDetails['truckTotalM3'] = this.editDetails['Total M3'];
  
        this.truckDetails['dimLength'] = this.editDetails['Length(M)'];
        this.truckDetails['dimWidth'] = this.editDetails['Width(M)'];
        this.truckDetails['dimHeight'] = this.editDetails['Height(M)'];

        this.truckDetails['truckBillRate'] = this.editDetails['Bill Rate'];
        this.truckDetails['truckTotalCharge'] = this.editDetails['Total Chrg'] ? this.formatCurrencySeperator(this.editDetails['Total Chrg']) : ''; //remove commas to avoid error
        this.truckDetails['truckTollCharge'] = this.editDetails['Toll Chrg'] ? this.formatCurrencySeperator(this.editDetails['Toll Chrg']) : ''; //remove commas to avoid error

        this.truckDetails['truckSelectedBillType'] = this.truckBillTypeList.getSelected(this.editDetails['Bill Rate Type'], 'BillType');
        if (this.truckDetails['truckSelectedBillType']) {
          this.billTypeSelected(this.truckDetails['truckSelectedBillType']);
        }
        this.calculateAllInput();

        if (this.truckDetails['truckSelectedType'] && this.truckDetails['truckSelectedBillType']){ // if Truck Type and Bill Type selected, run function to get bill code list
          this.truckTypeSelected(this.truckDetails['truckSelectedType'])
          this.billTypeSelected(this.truckDetails['truckSelectedBillType'])
        }

        if (this.truckDetails['truckSelectedBillCode']) // if Bill Code selected, run function to get Bill Rate
        {
          this.billCodeSelected(this.truckDetails['truckSelectedBillCode']) 
        }
      }) 
    } else if (this.title.includes('Cargo Info') || this.title.includes('Send To')){ this.calculateAllInput(); } // to initialize values during edit / add cargo info
  },
  watch: {
    truckBillCodeList: {
      handler: function(newList) {
        this.truckBillCodes = newList;

        this.$nextTick(() => {
          if (this.editDetails?.['Bill Code'] && this.truckBillCodes.length > 0) {
            this.truckDetails['truckSelectedBillCode'] = this.truckBillCodes.getSelected(this.editDetails['Bill Code'], 'BillRateCode');
            this.billcodemode = this.editDetails['Bill Code'] ? false : true;
          }
        })
      },
      deep: true,
    },
    billcodemode(newValue) {
      if (newValue === true) {
        this.truckDetails.truckSelectedBillCode = null; // clear selected Bill Code 
      }
    },
  }
}
</script>

<style lang="scss" scoped>
@import '@/css/all.scss';

.cargo-info-popup {
  background-color: rgba(0,0,0,0.2);
  width: 100%;
  height: calc(100% - 50px);
  position: fixed;
  top: 50px;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 110;

  > .popup-content {
    // height: calc(90% - 50px);
    background-color: white;
    width: 400px;
    position: relative;
    border-top-right-radius: 5px;
    border-top-left-radius: 5px;
    border: 1px solid rgba(0,0,0,0.2);

    > .popup-title {
      font-weight: bold;
      display: flex;
      justify-content: center;
      font-size: 1.1em;
      padding: 5px;
    }

    > .content-details {
      width: 100%;
      height: 100%;
      padding: 5px;
      // overflow: auto;
      overflow: visible;
      border-top-right-radius: 5px;
      border-top-left-radius: 5px;

      > div {
        display: flex;
        align-items: center;

        > div {
        display: flex;
        align-items: center;
        }
      }
    }

    > .popup-button {
      width: 100%;
      position: absolute;
      display: flex;
      align-items: center;
      padding: 3px;
      justify-content: flex-end;
      background-color: white;
      border-bottom-right-radius: 5px;
      border-bottom-left-radius: 5px;

      > .popup-error {
        color: red;
        text-align: right;
      }

      > button {
        margin-left: 5px;
      }
    }
  }

}
</style>